import { hasActiveSession } from 'app/modules';
import sessionEnums from 'enums/session';

export default function updateCustomerTypingState(typingState) {
  return (dispatch, getState, { messageGateway }) => {
    if (!hasActiveSession(getState())) {
      return;
    }

    return typingState === sessionEnums.TypingState.STARTED
      ? messageGateway.customerIsTyping()
      : messageGateway.customerStoppedTyping();
  };
}
